import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@popcart/tokens/tokens.css';
import './styles/fonts.css';
import './styles/app.css';
import './styles/dash.css';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { PrefsProvider } from './ui/prefs';
import { ToastProvider } from './ui/toast';
import { VersionBanner } from './ui/VersionBanner';
import { primeAudioOnGesture } from './ui/sound';
import { errorStatus } from './api';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2_000,
      // Don't hammer the API with retries for answers that won't change.
      retry: (n, err) => {
        const s = errorStatus(err);
        if (s === 401 || s === 403 || s === 404) return false;
        return n < 2;
      },
    },
    mutations: { retry: false },
  },
});

primeAudioOnGesture();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PrefsProvider>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
          <VersionBanner />
        </ToastProvider>
      </PrefsProvider>
    </QueryClientProvider>
  </StrictMode>,
);
